import * as React from 'react';
import moment from 'moment';
import type { JsonObject } from '@/app-package';
import { AppointmentDoc } from '@bb/domain/dist/schemas';

import PreviousAppointmentDetail from './PreviousAppointmentDetail';
import AppointmentDate from './AppointmentDate';

type PreviousAppointmentDetailsGroupProps = {
  appointmentDate: string;
  appointments: JsonObject<AppointmentDoc>[];
};

const PreviousAppointmentDetailsGroup = ({
  appointmentDate,
  appointments,
}: PreviousAppointmentDetailsGroupProps) => {
  const isToday = (date: string) =>
    moment(date).isSame(moment().format('YYYY-MM-DD'));

  return (
    <div className="row">
      <div className="col-lg-2 col-xs-5">
        <AppointmentDate
          appointmentDate={appointmentDate}
          isActive={isToday(appointmentDate)}
        />
      </div>
      <div className="col-lg-9 col-xs-5">
        {appointments.map(appointment => (
          <div className="row" key={appointment.id}>
            <div className="col-xs-12">
              <PreviousAppointmentDetail appointment={appointment} />
            </div>
          </div>
        ))}
      </div>
      <div className="col-lg-1 col-xs-2"></div>
    </div>
  );
};

export default PreviousAppointmentDetailsGroup;
